export default __webpack_public_path__ + "static/media/Products_PointOfSale.1dbeb590.png";